export default __webpack_public_path__ + "static/media/key3.5eec47b7.png";